import { createContext, useContext } from "react";

export interface PanelContextValue {
  panelId: number;
  panelName: string;
  panelTagline: string;
}

export const PanelContext = createContext<PanelContextValue | null>(null);

export function usePanelContext() {
  const value = useContext(PanelContext);
  if (!value) {
    throw new Error("Panel context is not available.");
  }
  return value;
}
